import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LinearProgress, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { getCaloriesPerMacro } from "@notemeal/shared-utils-macro-protocol";
export const useStyles = makeStyles(({ additionalColors: { blue100 } }) => createStyles({
    root: {
        display: "flex",
    },
    choBar: { backgroundColor: "green" },
    proBar: {
        backgroundColor: "blue",
    },
    fatBar: {
        backgroundColor: "red",
    },
    emptyBar: { backgroundColor: blue100 },
    caption: { display: "flex", justifyContent: "space-between" },
}));
export const StackedProgressBar = ({ macros, showKcals }) => {
    const classes = useStyles();
    const caloriesPerMacro = getCaloriesPerMacro(macros);
    const total = macros.kcal;
    const choBar = Math.round((caloriesPerMacro.cho / total) * 100) + "%";
    const proBar = Math.round((caloriesPerMacro.pro / total) * 100) + "%";
    const fatBar = Math.round((caloriesPerMacro.fat / total) * 100) + "%";
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classes.caption, children: [_jsx(Typography, { variant: "subtitle1", children: "Calories from Macros" }), showKcals && _jsx(Typography, { variant: "subtitle1", children: `${Math.round(total)}kcal` })] }), total === 0 && _jsx(LinearProgress, { classes: { bar: classes.emptyBar }, variant: "determinate", value: 100, "aria-valuetext": "0 kcal" }), _jsxs("div", { className: classes.root, children: [caloriesPerMacro.cho > 0 && (_jsx(LinearProgress, { style: { width: choBar }, classes: { bar: classes.choBar }, variant: "determinate", value: 100, "aria-label": "CHO", "aria-valuetext": choBar })), caloriesPerMacro.pro > 0 && (_jsx(LinearProgress, { style: { width: proBar }, classes: { bar: classes.proBar }, variant: "determinate", value: 100, "aria-label": "PRO", "aria-valuetext": proBar })), caloriesPerMacro.fat > 0 && (_jsx(LinearProgress, { style: { width: fatBar }, classes: { bar: classes.fatBar }, variant: "determinate", value: 100, "aria-label": "FAT", "aria-valuetext": fatBar }))] })] }));
};
//# sourceMappingURL=StackedProgressBar.js.map